import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMobileTopBarStore, type MobileTopBarConfig } from '../store/mobile-topbar-store.js';

/**
 * Declare the MobileShell top-bar contents for the current surface. Call from
 * a mobile page (or its mobile branch) — the shell renders this title/subtitle
 * instead of the generic route map, removing the redundant "top bar title +
 * in-content title" doubling that plagued the first mobile pass.
 *
 * Desktop never mounts the mobile branches, so this is inert there.
 *
 * Pass primitive fields (not an object literal) or memoise the config; the
 * effect re-runs on any field change.
 */
export function useMobileTopBar(config: MobileTopBarConfig): void {
  const { pathname } = useLocation();
  const set = useMobileTopBarStore((s) => s.set);
  const clear = useMobileTopBarStore((s) => s.clear);

  const { title, subtitle, back, onBack, hideActions, hideHeader, fullBleed } = config;

  useEffect(() => {
    set(pathname, { title, subtitle, back, onBack, hideActions, hideHeader, fullBleed });
    return () => clear(pathname);
  }, [pathname, title, subtitle, back, onBack, hideActions, hideHeader, fullBleed, set, clear]);
}
